module.exports = __webpack_public_path__ + "img/item_CommIllustration_06b.31b161b0.jpeg";